export default {
  'ar-AE': {
    Empty: 'فارغ',
  },
  'bg-BG': {
    Empty: 'Изпразни',
  },
  'cs-CZ': {
    Empty: 'Prázdné',
  },
  'da-DK': {
    Empty: 'Tom',
  },
  'de-DE': {
    Empty: 'Leer',
  },
  'el-GR': {
    Empty: 'Άδειο',
  },
  'en-US': {
    Empty: 'Empty',
  },
  'es-ES': {
    Empty: 'Vacío',
  },
  'et-EE': {
    Empty: 'Tühjenda',
  },
  'fi-FI': {
    Empty: 'Tyhjä',
  },
  'fr-FR': {
    Empty: 'Vide',
  },
  'he-IL': {
    Empty: 'ריק',
  },
  'hr-HR': {
    Empty: 'Prazno',
  },
  'hu-HU': {
    Empty: 'Üres',
  },
  'it-IT': {
    Empty: 'Vuoto',
  },
  'ja-JP': {
    Empty: '空',
  },
  'ko-KR': {
    Empty: '비어 있음',
  },
  'lt-LT': {
    Empty: 'Tuščias',
  },
  'lv-LV': {
    Empty: 'Tukšs',
  },
  'nb-NO': {
    Empty: 'Tom',
  },
  'nl-NL': {
    Empty: 'Leeg',
  },
  'pl-PL': {
    Empty: 'Pusty',
  },
  'pt-BR': {
    Empty: 'Vazio',
  },
  'pt-PT': {
    Empty: 'Vazio',
  },
  'ro-RO': {
    Empty: 'Gol',
  },
  'ru-RU': {
    Empty: 'Не заполнено',
  },
  'sk-SK': {
    Empty: 'Prázdne',
  },
  'sl-SI': {
    Empty: 'Prazen',
  },
  'sr-SP': {
    Empty: 'Prazno',
  },
  'sv-SE': {
    Empty: 'Tomt',
  },
  'tr-TR': {
    Empty: 'Boş',
  },
  'uk-UA': {
    Empty: 'Пусто',
  },
  'zh-CN': {
    Empty: '空',
  },
  'zh-TW': {
    Empty: '空白',
  },
};
